
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/receipt-document-scanners",
      function () {
        return require("private-next-pages/receipt-document-scanners.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/receipt-document-scanners"])
      });
    }
  